// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__5J-wW","slider":"Switch_slider__ZIcap","on":"Switch_on__8gdxo","danger":"Switch_danger__kl9U6"};